import { inject } from '@angular/core';
import { HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { DirectionService } from '../services/direction.service';
import { isTrustedApiRequest } from '../utils/api-url.util';

export const JwtInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const dirService = inject(DirectionService);

  if (!isTrustedApiRequest(req.url)) {
    return next(req);
  }

  const language = dirService.getCurrentDirection() === 'rtl' ? 'ar' : 'en';
  const token = authService.getAccessToken();

  if (token) {
    const modifiedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Accept-Language': language
      }
    });
    return next(modifiedReq);
  }

  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': language
    }
  });
  return next(modifiedReq);
};
